module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#play",
      toString: function () {
        return this.url;
      }
    }